<template>
  <div class="page flex-col" v-loading="!amount">
    <div class="group_1 flex-col">
      <v-head :meetingId="meetingId" :meetingRegisterId="meetingRegisterId" route="sourceName"></v-head>
      <div style="text-align:center; padding:30px 0;position: fixed;top: 1.5rem;z-index: 999;">
        <van-overlay :show="loading" :lock-scroll="true" style="z-index: 888;">
          <van-loading color="#fff" size="24px" vertical style="z-index: 999;margin-top: 50%;">支付中...</van-loading>
        </van-overlay>
        <van-overlay :show="loadingUpload" :lock-scroll="true" style="z-index: 888;">
          <van-loading color="#fff" size="24px" vertical style="z-index: 999;margin-top: 50%;">上传中...</van-loading>
        </van-overlay>
      </div>
      <div class="text-wrapper_8 flex-col" style="margin-top: 50px;text-align: center;">
        <span class="text_2">¥&nbsp;{{amount}}</span>
      </div>
      <div class="group_3 flex-col">
        <van-radio-group v-model="checked">
          <van-radio name="1" label-position="left">
            <div class="group_11 flex-row ">
              <div class="image-text_2 flex-row ">
                <img class="icon_1" referrerpolicy="no-referrer" src="../../../assets/images/weixin1.png" />
                <span class="text-group_1">微信支付</span>
              </div>
            </div>
          </van-radio>
          <van-radio name="2" label-position="left">
            <div class="group_11 flex-row">
              <div class="image-text_2 flex-row ">
                <img class="icon_1" referrerpolicy="no-referrer" src="../../../assets/images/user/duigong.png" />
                <span class="text-group_1">对公转账</span>
              </div>
            </div>
          </van-radio>
        </van-radio-group>
        <span class="text_4">请选择支付方式</span>
      </div>
      <div class="group_5 flex-col" v-if="checked == 2">
        <div class="group_8 flex-row justify-between">
          <span class="text_5">对公转账信息</span>
          <div class="image-text_3 flex-row justify-between" @click="copy">
            <img class="icon_2" referrerpolicy="no-referrer" src="../../../assets/images/user/copy .png" />
            <span class="text-group_2">一键复制</span>
          </div>
        </div>
        <div class="text-wrapper_12 flex-row justify-between">
          <span class="text_7">开户名称</span>
          <span class="text_12">中国地震学会</span>
        </div>
        <div class="text-wrapper_12 flex-row justify-between">
          <span class="text_9">银行账号</span>
          <span class="text_12">0200007619201134580</span>
        </div>
        <div class="text-wrapper_12 flex-row justify-between">
          <span class="text_11">开户行</span>
          <span class="text_12">工行海淀西区紫竹院支行</span>
        </div>
        <div class="text-wrapper_12 flex-row justify-between">
          <span class="text_13">注意事项</span>
          <span class="text_14">线下缴费汇款单附言栏要求：写清楚单位名称（如个人则写个人）、汇款人姓名、付款项目（如会费、会议注册费等）</span>
        </div>
        <div class="box_3 flex-col"></div>
      </div>
      <div class="group_6 flex-col" v-if="checked == 2">
        <span class="text_15">转账凭证</span>
        <div class="box_4 flex-col"></div>
        <!-- <span class="text_16">转账凭证示例</span>
        <div class="box_5 flex-col">
          <img src="../../../assets/images/user/mergeImage.png" />
        </div> -->
        <div class="text-wrapper_7">
          <span class="text_17">*</span>
          <span class="text_18">上传转帐凭证</span>
        </div>
        <van-uploader v-model="fileList" multiple :max-count="1" :after-read="afterRead" :before-read="beforeRead"
          @delete="(file, detail) => deleteImg(file, detail)">
          <img class="image_2" referrerpolicy="no-referrer" src="../../../assets//images/user/upload.png" />
        </van-uploader>
      </div>
    </div>
    <div class="box_6 flex-col">
      <button class="button_1 flex-col" @click="submitForm()">
        <span class="text_19">立即支付</span>
      </button>
    </div>
  </div>
</template>
<script>
  import {
    underLineSubmit,
    getAuthurlMeeting,
    meetingorderChangeDetails
  } from "@/api/dictionary"
  import vHead from "../../../components/payHead.vue"
  import { Uploader, RadioGroup, Radio, Toast, Overlay, Loading } from "vant"
  import * as imageConversion from "image-conversion"
  import Exif from "exif-js";
  export default {
    data() {
      return {
        title: "报名缴费",
        checked: "",
        fileList: [],
        constants: {},
        amount: null,
        event: "",
        loading: false,
        loadingUpload: false,
        meetingId: null,
        meetingGroupRegisterId: null,
        files: {},
        voucherFile: null,
        orderId: '',
        orderNopay: ''
      }
    },
    components: {
      vHead,
      [Radio.name]: Radio,
      [Uploader.name]: Uploader,
      [RadioGroup.name]: RadioGroup,
      [Toast.name]: Toast,
      [Loading.name]: Loading,
      [Overlay.name]: Overlay,
    },
    created() {
      let signupPayList = sessionStorage.getItem("Paypage")
      if (signupPayList) {
        let signupPayInfo = JSON.parse(signupPayList)
        this.meetingId = signupPayInfo.meetingId
        this.meetingRegisterId = signupPayInfo.id
      }
    },
    computed: {
      sourceName() {
        return this.$route.query && this.$route.query.sourceName
      }
    },
    methods: {
      copy() {
        const inputNode = document.createElement("input")
        inputNode.value =
          "开户名称：中国地震学会,开户行：工行海淀西区紫竹院支行,银行账号:0200007619201134580"
        document.body.appendChild(inputNode)
        inputNode.select()
        document.execCommand("Copy")
        this.$message.success("复制成功") //这是element plus提示用户复制成功的信息提醒，根据自己实际需求加
        document.body.removeChild(inputNode)
      },
      // 返回布尔值
      beforeRead(file) {
        const isJPG =
          file.type === 'image/jpeg' ||
          file.type === 'image/png' ||
          file.type === 'image/jpg';
        if (!isJPG) {
          Toast('请上传jpg,png,jpeg格式图片');
          return false;
        }

        return true;
      },
      afterRead(file) {
        this.imgPreview(file.file);
        // this.imgCom(event).then((res) => {
        //   console.log('压缩后', res.size / 1024 / 1024)
        //   this.file = res
        //   this.portraitName = this.file.name
        // })
      },
      // 处理图片

      imgPreview(file) {
        this.loadingUpload = true
        let self = this
        let Orientation
        //   去获取拍照时的信息，解决拍出来的照片旋转问题   npm install exif-js --save   这里需要安装一下包
        Exif.getData(file, function () {
          Orientation = Exif.getTag(this, "Orientation")
        })
        // 看支持不支持FileReader
        if (!file || !window.FileReader) {
          Toast("请按规定上传文件")
          return
        }
        console.log('image', file, /^image/.test(file.type))
        this.files.name = file.name // 获取文件名
        this.files.type = file.type // 获取类型
        if (/^image/.test(file.type)) {
          // 创建一个reader
          let reader = new FileReader()
          // 将图片2将转成 base64 格式
          reader.readAsDataURL(file)
          // 读取成功后的回调
          reader.onloadend = function () {
            let result = this.result
            let img = new Image()
            img.src = result
            //判断图片是否大于500K,是就直接上传，反之压缩图片
            if (this.result.length <= 500 * 1024) {
              // 上传图片
              // alert('11')
              console.log('11', this.result)
              self.afterPortraitFile(this.result, true)
              // return this.successShow
            } else {
              // alert('22',)
              img.onload = function () {
                let data = self.compress(img, Orientation)
                console.log(data)
                // 上传图片
                self.afterPortraitFile(data, true)
                // return this.successShow
              }
            }
          }
          return true
        } else {
          // alert('33', file)
          console.log('33', file)
          self.afterPortraitFile(file, false)
          // return this.successShow
          return true
        }
      },
      afterPortraitFile(base64, stataus) {
        let file = ""
        if (stataus) {
          file = this.dataURLtoFile(base64)
        } else {
          file = base64
        }
        this.voucherFile = file
        this.loadingUpload = false
      },
      //将base64转换为文件
      dataURLtoFile(dataurl) {
        console.log(dataurl);
        var arr = dataurl.split(","),
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], this.files.name, {
          type: this.files.type,
        });
      },
      // 压缩图片
      compress(img, Orientation) {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        //瓦片canvas
        let tCanvas = document.createElement("canvas");
        let tctx = tCanvas.getContext("2d");
        // let initSize = img.src.length;
        let width = img.width;
        let height = img.height;
        //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        let ratio;
        if ((ratio = (width * height) / 4000000) > 1) {
          // console.log("大于400万像素");
          ratio = Math.sqrt(ratio);
          width /= ratio;
          height /= ratio;
        } else {
          ratio = 1;
        }
        canvas.width = width;
        canvas.height = height;
        //    铺底色
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        //如果图片像素大于100万则使用瓦片绘制
        let count;
        if ((count = (width * height) / 1000000) > 1) {
          // console.log("超过100W像素");
          count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
          //      计算每块瓦片的宽和高
          let nw = ~~(width / count);
          let nh = ~~(height / count);
          tCanvas.width = nw;
          tCanvas.height = nh;
          for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
              tctx.drawImage(
                img,
                i * nw * ratio,
                j * nh * ratio,
                nw * ratio,
                nh * ratio,
                0,
                0,
                nw,
                nh
              );
              ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
          }
        } else {
          ctx.drawImage(img, 0, 0, width, height);
        }
        // //修复ios上传图片的时候 被旋转的问题
        // if (Orientation != "" && Orientation != 1) {
        //   switch (Orientation) {
        //     case 6: //需要顺时针（向左）90度旋转
        //       this.rotateImg(img, "left", canvas);
        //       break;
        //     case 8: //需要逆时针（向右）90度旋转
        //       this.rotateImg(img, "right", canvas);
        //       break;
        //     case 3: //需要180度旋转
        //       this.rotateImg(img, "right", canvas); //转两次
        //       this.rotateImg(img, "right", canvas);
        //       break;
        //   }
        // }
        //进行最小压缩
        let ndata = canvas.toDataURL("image/jpeg", 0.3);
        tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
        return ndata;
      },
      // 旋转图片
      rotateImg(img, direction, canvas) {
        //最小与最大旋转方向，图片旋转4次后回到原方向
        const min_step = 0;
        const max_step = 3;
        if (img == null) return;
        //img的高度和宽度不能在img元素隐藏后获取，否则会出错
        let height = img.height;
        let width = img.width;
        let step = 2;
        if (step == null) {
          step = min_step;
        }
        if (direction == "right") {
          step++;
          //旋转到原位置，即超过最大值
          step > max_step && (step = min_step);
        } else {
          step--;
          step < min_step && (step = max_step);
        }
        //旋转角度以弧度值为参数
        let degree = (step * 90 * Math.PI) / 180;
        let ctx = canvas.getContext("2d");
        switch (step) {
          case 0:
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            break;
          case 1:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, 0, -height);
            break;
          case 2:
            canvas.width = width;
            canvas.height = height;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, -height);
            break;
          case 3:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, 0);
            break;
        }
      },
      deleteImg(file, detail) {
        this.fileList = []
        this.files = {};
        this.voucherFile = null;
      },


      submitForm() {
        if (this.checked == 1) {
          this.selectPayType()
          return
        }
        if (this.checked == 2 && !this.voucherFile) {
          Toast.fail("请上传凭证")
          return false
        }
        if (this.checked != 1 && this.checked != 2) {
          Toast.fail("请选择支付方式")
          return false
        }
        let params = new FormData()
        this.loading = true
        params.append("file", this.voucherFile)
        params.append("orderId", this.orderId)
        underLineSubmit(params).then((res) => {
          if (res.success) {
            // this.titleFileId = res.result.id;
            // sessionStorage.setItem("meetingOrderInfo", JSON.stringify(res.result))
            this.loading = false
            if (!this.loading) {
              Toast.success("支付成功")
              this.$router.push({
                name: "invoicePage",
                query: {
                  orderId: this.orderId,
                },
              })
            }
          } else {
            Toast.fail("支付失败")
            this.loading = false
          }
        }).catch(error => {
          console.log(error)
          this.loading = false
          Toast.fail("支付失败")
        })
      },
      selectPayType() {
        if (!this.orderNopay) {
          return Toast("没有查询到您的订单")
        }
        getAuthurlMeeting({
          orderNo: this.orderNopay,
          memberId: sessionStorage.getItem("memberId"),
          access_token: sessionStorage.getItem("access_token"),
        }).then((res) => {
          console.log('aaurl', res)

          if (res.success) {
            let url = res.result
            console.log(url)
            window.location = url
          }
        })
      },
    },

    mounted() {
      this.orderId = this.$route.query && this.$route.query.orderId
      if (this.orderId) {
        meetingorderChangeDetails({ orderId: this.orderId }).then((res) => {
          if (res.success) {
            document.title = res.result.meetingName
            this.amount = res.result.amount
            this.orderNopay = res.result.orderNo
            // if (res.result.orderStatus != 2) {
            //   this.$router.push({ name: "SignUpmeetingCenter" })
            // }
          } else {
            Toast.fail(res.message)
            this.$router.push({
              name: "SignUpmeetingCenter",
            })
          }
        })
      }
    },
  }
</script>
<style scoped>
  .page {
    background-color: rgba(245, 245, 247, 1);
    position: relative;
    overflow: hidden;
  }

  /deep/.van-uploader__preview-image {
    margin-left: 26px;
    margin-top: 15px;
  }

  /deep/.van-uploader__preview-delete {
    top: 10px;
  }

  /deep/.van-loading__text {
    font-size: 20px;
  }

  /deep/.van-loading__circular {
    width: 20px;
    height: 20px;
  }

  .box_1 {
    height: 1602px;
    margin-bottom: -316px;
    padding-bottom: 316px;
  }

  .group_1 {
    background-color: rgba(245, 245, 247, 1);
  }

  .group {
    padding: 0 25px;
  }

  .group_29 {
    position: relative;
    padding: 16px 8px 11px 8px;
  }

  .group_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    height: 97px;
    padding: 18px 0 0 2px;
  }

  .block {
    height: 245px;
  }

  .image_1 {
    width: 361px;
    height: 17px;
    margin: 0 16px 0 35px;
  }

  .text_1 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 2px;
  }

  .nav-bar_2 {
    width: 412px;
    margin-top: 14px;
    background: none;
    height: 49px;
  }

  .nav-bar_2 .van-nav-bar__content {
    height: 100%;
  }

  .nav-bar_2 .van-nav-bar__left {
    padding: 0 0 0 26px;
    align-items: start;
  }

  .label_1 {
    width: 26px;
    height: 21px;
    margin: 11px 0 4px 3px;
  }

  .text-wrapper_8 {
    padding: 24px 0 22px 0;
  }

  .text_2 {
    overflow-wrap: break-word;
    color: #000;
    font-size: 40px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: center;
    white-space: nowrap;
    line-height: 56px;
  }

  .group_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    position: relative;
    align-self: center;
    margin-top: -1px;
    padding-top: 42px;
    padding-right: 22px;
    margin: 16px 20px 14px 20px;
  }

  .text-wrapper_2 {
    background: url(../../../assets/images/user/weixinbac.png) 100% no-repeat;
    background-size: 100% 100%;
    justify-content: flex-center;
    width: 240px;
    padding: 44px 32px 52px 32px;
  }

  .text_3 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 20px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 28px;
  }

  .group_11 {
    background-size: 100% 100%;
    padding: 29px 135px 40px 16px;
  }

  .image-text_2 {
    width: 154px;
    display: flex;
    align-items: center;
  }

  .icon_1 {
    width: 58px;
    height: 58px;
  }

  .text-group_1 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 20px;
    font-weight: NaN;
    text-align: left;
    margin-left: 11px;
    white-space: nowrap;
    line-height: 28px;
    margin-top: 11px;
  }

  .text_4 {
    position: absolute;
    left: 20px;
    top: 24px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .group_5 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 6px;
    align-self: center;
    margin-top: 16px;
    position: relative;
    padding: 15px 0px 19px 20px;
  }

  .group_8 {
    width: 97%;
  }

  .text_5 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .image-text_3 {
    width: 62px;
    margin: 3px 0 2px 0;
  }

  .icon_2 {
    width: 10px;
    height: 11px;
    margin: 3px 0 3px 0;
  }

  .text-group_2 {
    overflow-wrap: break-word;
    color: rgba(0, 103, 255, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .text-wrapper_9 {
    width: 205px;
    margin: 29px 50px 0 2px;
  }

  .text_7 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_8 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text-wrapper_10 {
    width: 240px;
    margin: 20px 60px 0 2px;
  }

  .text_9 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_10 {
    width: 237px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text-wrapper_11 {
    width: 260px;
    margin: 20px 60px 0 2px;
  }

  .text_11 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_12 {
    width: 237px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text-wrapper_12 {
    width: 330px;
    margin: 20px 8px 0 2px;
  }

  .text_13 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_14 {
    width: 237px;
    height: 60px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .van-uploader__wrapper {
    flex-wrap: nowrap;
  }

  .van-uploader__preview {
    margin: 14px;
  }

  .box_3 {
    background-color: rgba(230, 230, 232, 1);
    position: absolute;
    left: 2px;
    top: 50px;
    width: 100%;
    height: 1px;
  }

  .group_6 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 6px;
    align-self: center;
    width: 100%;
    margin-top: 16px;
    padding: 15px 0 28px 0;
  }

  .text_15 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 0 306px 0 18px;
  }

  .box_4 {
    background-color: rgba(230, 230, 232, 1);
    width: 388px;
    height: 1px;
    margin-top: 13px;
  }

  .text_16 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 15px 287px 0 17px;
  }

  .box_5 {
    width: 334px;
    height: 131px;
    margin: 8px 34px 0 20px;
  }

  .text-wrapper_7 {
    width: 96px;
    height: 20px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 10px 275px 0 17px;
  }

  .text_17 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_18 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .image_2 {
    width: 70px;
    height: 70px;
    margin: 16px 277px 0 41px;
  }

  .box_6 {
    padding: 30px 47px 9px 47px;
    margin-bottom: 20px;
  }

  .button_1 {
    background-color: #1989fa;
    border-radius: 28px;
    width: 100%;
    padding: 13px 0 13px 0;
  }

  .text_19 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    width: 100%;
    line-height: 22px;
  }

  .image_3 {
    width: 414px;
    height: 38px;
    margin-top: -1px;
  }

  .justify-between {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
  }

  .flex-row {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    flex-direction: row;
  }

  /deep/.van-radio__label--left {
    width: 280px;
  }
</style>
